import { render, staticRenderFns } from "./WayfinderStyle.vue?vue&type=template&id=32ad54f9&"
import script from "./WayfinderStyle.vue?vue&type=script&lang=ts&"
export * from "./WayfinderStyle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports